<template>
    <table class="meneta" style="width: 100%;" v-if="list.length">
	<thead>
		<tr>
			<td width="15%">Name</td>
			<td width="20%">Base Material</td>
			<td width="23%">Shim Construction</td>
			<td width="20%" align="center">Download</td>
			<td width="22%">&nbsp;</td>
		</tr>
	</thead>
	<tbody>
        <tr v-for="item in formattedList" :key="item.id">
            <td v-text="item.post_title"></td>
            <td v-text="item.rdco_type"></td>
            <td><img :src="item.thumbail_url"></td>
            <td align="center">
                <a v-if="seeSpecifications" :href="item.pdf_download" target="_blank" class="pdf-icon"></a>
                <a v-if="!seeSpecifications" href="#login" target="_blank" class="fancybox pdf-icon"></a>
            </td>
            <td>
                <div class="button small sky-blue right">
                    <a v-if="seeSpecifications" :href="item.permalink">View details &rarr;</a>
                    <a v-if="!seeSpecifications" href="#login" target="_blank" class="fancybox">View details &rarr;</a>
                </div>
            </td>
        </tr>
    </tbody>
	</table>
    <p v-else-if="loading">Loading shims...</p>
    <p v-else-if="fetchedData">No results</p>
</template>

<script>
export default {
    props: {
        config: {type: Object, default() {return { }}},
        list: {type: Array, default() {return [ ]}},
        loading: {type: Boolean, default: false},
        fetchedData: {type: Boolean, default: false }
    },
    computed: {
        formattedList() {
            return this.list.map((item) => {
                return item;
            });
        },
        seeSpecifications() {
            return this.config.see_specification_capability === "1" ? true : false;
        }
    },
}
</script>